export const universities = [
  {
    id: '1',
    name: 'جامعة الملك سعود',
    nameEn: 'King Saud University',
    logo: 'https://public.readdy.ai/ai/img_res/f6e2865c95eec4d9b643b909b8d12498.jpg',
    type: 'government',
    status: 'open',
    closingDate: '2025-02-15',
    closingDateHijri: '17 شعبان 1446',
    studyMode: 'onsite',
    gender: 'both',
    region: 'الرياض',
    city: 'الرياض',
    level: 'bachelor',
    majors: ['الهندسة', 'الطب', 'العلوم', 'الآداب', 'إدارة الأعمال'],
    departments: ['الهندسة', 'الطب', 'العلوم'],
    fees: 'مجاني',
    duration: '4-6 سنوات',
    requirements: 'شهادة الثانوية العامة بنسبة لا تقل عن 80%، اجتياز اختبارات القدرات والتحصيلي',
    officialLink: 'https://admission.ksu.edu.sa',
    registrationLink: 'https://admission.ksu.edu.sa',
    location: 'الرياض، المملكة العربية السعودية',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Saudi%20Arabian%20university%20campus%20building%20with%20Islamic%20architecture%20elements%2C%20beautiful%20landscaped%20gardens%2C%20students%20walking%2C%20bright%20sunny%20day%2C%20professional%20photography%2C%20clean%20simple%20background%20highlighting%20the%20main%20building&width=800&height=600&seq=ksu1img001&orientation=landscape',
    deadline: '15 فبراير 2025',
    description: 'جامعة الملك سعود هي أول جامعة تأسست في المملكة العربية السعودية، وتعد من أعرق الجامعات وأكثرها تميزاً في المنطقة',
    bgColor: 'bg-pink-50',
  },
  {
    id: '2',
    name: 'جامعة الملك عبدالعزيز',
    nameEn: 'King Abdulaziz University',
    logo: 'https://readdy.ai/api/search-image?query=King%20Abdulaziz%20University%20official%20logo%20emblem%20on%20white%20background%2C%20professional%2C%20clean%2C%20high%20quality%2C%20centered%20composition%2C%20Saudi%20Arabian%20university%20branding&width=200&height=200&seq=kau002&orientation=squarish',
    type: 'government',
    status: 'closing-soon',
    closingDate: '2025-01-28',
    closingDateHijri: '28 رجب 1446',
    studyMode: 'both',
    gender: 'both',
    region: 'مكة المكرمة',
    city: 'جدة',
    level: 'bachelor',
    majors: ['الهندسة', 'الطب', 'الاقتصاد', 'علوم الحاسب', 'العلوم البحرية'],
    departments: ['الهندسة', 'الطب', 'علوم الحاسب'],
    fees: 'مجاني',
    duration: '4-6 سنوات',
    requirements: 'شهادة الثانوية العامة، اجتياز اختبارات القدرات والتحصيلي بنسب محددة حسب التخصص',
    officialLink: 'https://admission.kau.edu.sa',
    registrationLink: 'https://admission.kau.edu.sa',
    location: 'جدة، المملكة العربية السعودية',
    image: 'https://readdy.ai/api/search-image?query=Prestigious%20Saudi%20university%20campus%20with%20modern%20architecture%2C%20palm%20trees%2C%20coastal%20city%20view%2C%20students%20in%20courtyard%2C%20professional%20photography%2C%20clean%20simple%20background%20highlighting%20the%20main%20building&width=800&height=600&seq=kau2img002&orientation=landscape',
    deadline: '28 يناير 2025',
    description: 'جامعة الملك عبدالعزيز من أكبر الجامعات السعودية وتتميز بموقعها الاستراتيجي في مدينة جدة',
    bgColor: 'bg-emerald-50',
  },
  {
    id: '3',
    name: 'جامعة الإمام محمد بن سعود الإسلامية',
    nameEn: 'Imam Mohammad Ibn Saud Islamic University',
    logo: 'https://readdy.ai/api/search-image?query=Imam%20Mohammad%20Ibn%20Saud%20Islamic%20University%20official%20logo%20emblem%20on%20white%20background%2C%20professional%2C%20clean%2C%20high%20quality%2C%20centered%20composition%2C%20Saudi%20Arabian%20university%20branding&width=200&height=200&seq=imamu003&orientation=squarish',
    type: 'government',
    status: 'open',
    closingDate: '2025-02-20',
    closingDateHijri: '22 شعبان 1446',
    studyMode: 'onsite',
    gender: 'both',
    region: 'الرياض',
    city: 'الرياض',
    level: 'bachelor',
    majors: ['الشريعة', 'أصول الدين', 'اللغة العربية', 'الدعوة', 'الاقتصاد الإسلامي'],
    departments: ['الشريعة', 'اللغة العربية', 'الآداب'],
    fees: 'مجاني',
    duration: '4 سنوات',
    requirements: 'شهادة الثانوية العامة، حفظ أجزاء من القرآن الكريم لبعض التخصصات',
    officialLink: 'https://imamu.edu.sa',
    registrationLink: 'https://imamu.edu.sa',
    location: 'الرياض، المملكة العربية السعودية',
    image: 'https://readdy.ai/api/search-image?query=Islamic%20university%20campus%20with%20traditional%20Islamic%20architecture%2C%20grand%20mosque%20dome%2C%20beautiful%20courtyard%2C%20students%20studying%2C%20professional%20photography%2C%20clean%20simple%20background%20highlighting%20the%20main%20building&width=800&height=600&seq=imamu3img003&orientation=landscape',
    deadline: '20 فبراير 2025',
    description: 'جامعة متخصصة في العلوم الشرعية والعربية مع تقديم تخصصات أخرى متنوعة',
    bgColor: 'bg-gray-50',
  },
  {
    id: '4',
    name: 'جامعة الأمير سلطان',
    nameEn: 'Prince Sultan University',
    logo: 'https://readdy.ai/api/search-image?query=Prince%20Sultan%20University%20official%20logo%20emblem%20on%20white%20background%2C%20professional%2C%20clean%2C%20high%20quality%2C%20centered%20composition%2C%20Saudi%20Arabian%20university%20branding&width=200&height=200&seq=psu004&orientation=squarish',
    type: 'private',
    status: 'open',
    closingDate: '2025-03-01',
    closingDateHijri: '1 رمضان 1446',
    studyMode: 'onsite',
    gender: 'both',
    region: 'الرياض',
    city: 'الرياض',
    level: 'bachelor',
    majors: ['هندسة الحاسب', 'إدارة الأعمال', 'الهندسة المعمارية', 'القانون'],
    departments: ['الهندسة', 'إدارة الأعمال'],
    fees: '60,000 - 80,000 ريال سنوياً',
    duration: '4-5 سنوات',
    requirements: 'شهادة الثانوية العامة بنسبة لا تقل عن 75%، اختبار القدرات',
    officialLink: 'https://www.psu.edu.sa',
    registrationLink: 'https://www.psu.edu.sa',
    location: 'الرياض، المملكة العربية السعودية',
    image: 'https://readdy.ai/api/search-image?query=Modern%20private%20university%20campus%20with%20contemporary%20architecture%2C%20glass%20buildings%2C%20green%20spaces%2C%20students%20with%20laptops%2C%20professional%20photography%2C%20clean%20simple%20background%20highlighting%20the%20main%20building&width=800&height=600&seq=psu4img004&orientation=landscape',
    deadline: '1 مارس 2025',
    description: 'أول جامعة أهلية غير ربحية في المملكة، تتميز بجودة التعليم والاعتمادات الدولية',
    bgColor: 'bg-amber-50',
  },
  {
    id: '5',
    name: 'جامعة الملك فهد للبترول والمعادن',
    nameEn: 'King Fahd University of Petroleum and Minerals',
    logo: 'https://readdy.ai/api/search-image?query=King%20Fahd%20University%20of%20Petroleum%20and%20Minerals%20official%20logo%20emblem%20on%20white%20background%2C%20professional%2C%20clean%2C%20high%20quality%2C%20centered%20composition%2C%20Saudi%20Arabian%20university%20branding&width=200&height=200&seq=kfupm005&orientation=squarish',
    type: 'government',
    status: 'open',
    closingDate: '2025-02-10',
    closingDateHijri: '12 شعبان 1446',
    studyMode: 'onsite',
    gender: 'male',
    region: 'الشرقية',
    city: 'الظهران',
    level: 'bachelor',
    majors: ['هندسة البترول', 'الهندسة الكيميائية', 'علوم الحاسب', 'الهندسة الميكانيكية'],
    departments: ['الهندسة', 'علوم الحاسب', 'العلوم'],
    fees: 'مجاني',
    duration: '4-5 سنوات',
    requirements: 'شهادة الثانوية العامة بنسبة عالية، اجتياز اختبارات القدرات والتحصيلي بدرجات متميزة',
    officialLink: 'https://www.kfupm.edu.sa',
    registrationLink: 'https://www.kfupm.edu.sa',
    location: 'الظهران، المملكة العربية السعودية',
    image: 'https://readdy.ai/api/search-image?query=Technical%20university%20campus%20with%20engineering%20buildings%2C%20modern%20laboratories%2C%20technology%20facilities%2C%20students%20with%20equipment%2C%20professional%20photography%2C%20clean%20simple%20background%20highlighting%20the%20main%20building&width=800&height=600&seq=kfupm5img005&orientation=landscape',
    deadline: '10 فبراير 2025',
    description: 'جامعة متخصصة في مجالات الهندسة والعلوم، وتعد من أفضل الجامعات في المنطقة',
    bgColor: 'bg-blue-50',
  },
  {
    id: '6',
    name: 'جامعة الملك خالد',
    nameEn: 'King Khalid University',
    logo: 'https://readdy.ai/api/search-image?query=King%20Khalid%20University%20official%20logo%20emblem%20on%20white%20background%2C%20professional%2C%20clean%2C%20high%20quality%2C%20centered%20composition%2C%20Saudi%20Arabian%20university%20branding&width=200&height=200&seq=kku006&orientation=squarish',
    type: 'government',
    status: 'open',
    closingDate: '2025-02-25',
    closingDateHijri: '27 شعبان 1446',
    studyMode: 'both',
    gender: 'both',
    region: 'عسير',
    city: 'أبها',
    level: 'bachelor',
    majors: ['الطب', 'الهندسة', 'التربية', 'العلوم الإنسانية', 'علوم الحاسب'],
    departments: ['الطب', 'الهندسة', 'الآداب'],
    fees: 'مجاني',
    duration: '4-6 سنوات',
    requirements: 'شهادة الثانوية العامة، اجتياز اختبارات القدرات والتحصيلي',
    officialLink: 'https://www.kku.edu.sa',
    registrationLink: 'https://www.kku.edu.sa',
    location: 'أبها، المملكة العربية السعودية',
    image: 'https://readdy.ai/api/search-image?query=Mountain%20region%20university%20campus%20with%20scenic%20views%2C%20modern%20buildings%2C%20natural%20landscape%2C%20students%20outdoors%2C%20professional%20photography%2C%20clean%20simple%20background%20highlighting%20the%20main%20building&width=800&height=600&seq=kku6img006&orientation=landscape',
    deadline: '25 فبراير 2025',
    description: 'جامعة حكومية تخدم منطقة عسير والمناطق المجاورة بتخصصات متنوعة',
    bgColor: 'bg-teal-50',
  },
  {
    id: '7',
    name: 'الجامعة السعودية الإلكترونية',
    nameEn: 'Saudi Electronic University',
    logo: 'https://readdy.ai/api/search-image?query=Saudi%20Electronic%20University%20official%20logo%20emblem%20on%20white%20background%2C%20professional%2C%20clean%2C%20high%20quality%2C%20centered%20composition%2C%20Saudi%20Arabian%20university%20branding&width=200&height=200&seq=seu007&orientation=squarish',
    type: 'government',
    status: 'open',
    closingDate: '2025-03-15',
    closingDateHijri: '15 رمضان 1446',
    studyMode: 'online',
    gender: 'both',
    region: 'جميع المناطق',
    city: 'الرياض',
    level: 'bachelor',
    majors: ['إدارة الأعمال', 'المالية', 'التجارة الإلكترونية', 'علوم الحاسب', 'الصحة العامة'],
    departments: ['إدارة الأعمال', 'علوم الحاسب'],
    fees: '130 ريال للساعة الدراسية',
    duration: '4 سنوات',
    requirements: 'شهادة الثانوية العامة، إجادة استخدام الحاسب والإنترنت',
    officialLink: 'https://www.seu.edu.sa',
    registrationLink: 'https://www.seu.edu.sa',
    location: 'التعليم عن بعد - جميع المناطق',
    image: 'https://readdy.ai/api/search-image?query=Digital%20learning%20university%20campus%20with%20technology%20center%2C%20online%20education%20facilities%2C%20students%20with%20computers%2C%20modern%20digital%20environment%2C%20professional%20photography%2C%20clean%20simple%20background%20highlighting%20the%20main%20building&width=800&height=600&seq=seu7img007&orientation=landscape',
    deadline: '15 مارس 2025',
    description: 'جامعة حكومية متخصصة في التعليم الإلكتروني والتعليم المدمج',
    bgColor: 'bg-violet-50',
  },
  {
    id: '8',
    name: 'جامعة الأميرة نورة بنت عبدالرحمن',
    nameEn: 'Princess Nourah bint Abdulrahman University',
    logo: 'https://readdy.ai/api/search-image?query=Princess%20Nourah%20bint%20Abdulrahman%20University%20official%20logo%20emblem%20on%20white%20background%2C%20professional%2C%20clean%2C%20high%20quality%2C%20centered%20composition%2C%20Saudi%20Arabian%20university%20branding&width=200&height=200&seq=pnu008&orientation=squarish',
    type: 'government',
    status: 'closing-soon',
    closingDate: '2025-01-30',
    closingDateHijri: '30 رجب 1446',
    studyMode: 'onsite',
    gender: 'female',
    region: 'الرياض',
    city: 'الرياض',
    level: 'bachelor',
    majors: ['الطب', 'الصيدلة', 'التمريض', 'التربية', 'الآداب', 'إدارة الأعمال'],
    departments: ['الطب', 'الآداب', 'إدارة الأعمال'],
    fees: 'مجاني',
    duration: '4-6 سنوات',
    requirements: 'شهادة الثانوية العامة، اجتياز اختبارات القدرات والتحصيلي',
    officialLink: 'https://www.pnu.edu.sa',
    registrationLink: 'https://www.pnu.edu.sa',
    location: 'الرياض، المملكة العربية السعودية',
    image: 'https://readdy.ai/api/search-image?query=Large%20women%20university%20campus%20with%20elegant%20architecture%2C%20beautiful%20gardens%2C%20female%20students%20walking%2C%20modern%20facilities%2C%20professional%20photography%2C%20clean%20simple%20background%20highlighting%20the%20main%20building&width=800&height=600&seq=pnu8img008&orientation=landscape',
    deadline: '30 يناير 2025',
    description: 'أكبر جامعة للبنات في العالم، تقدم تخصصات متنوعة في بيئة تعليمية متميزة',
    bgColor: 'bg-rose-50',
  },
];
